module.exports = __webpack_public_path__ + "img/banner-principal-decorativo-1.f16ce8be.png";